/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface NoticeWhatsNewListPayload {
    isMobile?: boolean;
}

export interface WhatsNewListItem {
    careerId: string;
    careerTypeId: number;
    classId: string;
    isBtnApply: number;
    isBtnResultApply: number;
    messageId: string;
    messageList: Array<string>;
    startDateStr: string;
    titleList: Array<string>;
}

export interface NoticeWhatsNewListResponse {
    whatsNewList: WhatsNewListItem[];
}

// What'sNewの一覧表示用Service
class NoticeWhatsNewListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "noticeWhatsNewList");
    }

    public async noticeWhatsNewList(
        payload: NoticeWhatsNewListPayload,
        resolved: (json: NoticeWhatsNewListResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as NoticeWhatsNewListResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default NoticeWhatsNewListService;
